import { ITheme } from "../../utils/theme"

export const subHeaderStyles = {
  color: (theme: ITheme) => theme.palette.blue[600],
}

export const paginationStyles = {
  padding: 0,
  paddingTop: 1,
  paddingBottom: 1,
}